import { render } from "./OrganizePage.vue?vue&type=template&id=2579fe94&scoped=true"
import script from "./OrganizePage.vue?vue&type=script&lang=js"
export * from "./OrganizePage.vue?vue&type=script&lang=js"

import "./OrganizePage.vue?vue&type=style&index=0&id=2579fe94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2579fe94"]])

export default __exports__